import React from 'react'
import { Field, reduxForm } from 'redux-form'
import deepEqual from 'deep-equal'
import { connect } from 'react-redux'
import { useFlags } from 'flags'
import { dataTypes } from '@adalo/constants'

import { getOptions, getSimplePropertyOptions } from 'utils/dataTypes'
import { singularize, pluralize } from 'utils/strings'

import { getTable } from 'ducks/apps/datasources'

import WrappedSelect from 'components/Shared/Forms/WrappedSelect'
import Icon from 'components/Shared/Icon'
import Button from 'components/Shared/Button'
import GoogleHelpLink from 'components/Shared/GoogleHelpLink'
import PrerequisiteAlert from 'components/Shared/PrerequisiteAlert'

import { getThirdPartyApiKeyFor } from 'ducks/thirdPartyApiKeys'

import { THEMES } from '../../../../../../../constants'

const FORM_NAME = 'accordionChildrenContent'

const customComparator = (optionValue, value) => {
  if (value && value.type) {
    value = 'relationship'
  }

  return deepEqual(value, optionValue)
}

const AccordionChildrenContent = props => {
  const {
    handleSubmit,
    tables,
    tableId,
    datasourceId,
    relationshipTable,
    initialValues,
    googleApiKey,
  } = props

  const { hasLocationDataType } = useFlags()

  const table = tables.find(t => t.tableId === tableId)
  const isAPI = table.type === 'api'

  let name

  if (relationshipTable?.name) {
    name = relationshipTable.name
  }

  if (initialValues?.type) {
    const { type } = initialValues

    if (type.type) {
      switch (type.type) {
        case 'manyToMany':
          name = pluralize(name)

          break
        case 'belongsTo':
        default:
          name = singularize(name)

          break
      }
    }
  }

  let menu = isAPI
    ? getSimplePropertyOptions({ api: true, hasLocationDataType })
    : getOptions(tables, datasourceId, hasLocationDataType)

  if (!isAPI) {
    menu = menu.concat([
      {
        label: (
          <>
            <Icon type="lock" />
            Password
          </>
        ),
        value: 'password',
      },
      {
        label: name,
        value: 'relationship',
      },
    ])
  }

  const closeAccordion = () => {
    const { closeAccordion, tableId } = props

    return closeAccordion(tableId)
  }

  const getPrerequisites = () => {
    if (!initialValues) {
      return null
    }

    let name
    let isPrerequisiteMet
    let footer = null

    switch (initialValues.type) {
      case dataTypes.LOCATION:
        name = 'Google Maps API Key'
        isPrerequisiteMet = googleApiKey && googleApiKey.isValid
        footer = <GoogleHelpLink />

        break
      default:
        return null
    }

    return (
      <PrerequisiteAlert
        isPrerequisiteMet={isPrerequisiteMet}
        name={name}
        footer={footer}
        context="data"
      />
    )
  }

  return (
    <form
      className="data-edit-collection-property form-inspect-field-wrapper"
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <div className="library-inspect-menu-control">
        <p>Type</p>
        <Field
          name="type"
          component={WrappedSelect}
          placeholder="Select Type"
          options={menu}
          comparator={customComparator}
          disabled={!isAPI}
          menuTheme={THEMES.DATA}
        />
      </div>
      <div className="library-inspect-text-control">
        <p>Name</p>
        <div className="library-inspect-text-control-input-wrapper">
          <Field
            name="name"
            component="input"
            placeholder="Property Name"
            className="library-inspect-text-control-input"
            disabled={isAPI}
          />
        </div>
      </div>
      {getPrerequisites()}
      <div className="actions">
        <Button type="button" text onClick={closeAccordion}>
          Cancel
        </Button>
        <Button orange>Save</Button>
      </div>
    </form>
  )
}

const WrappedAccordionChildrenContent = reduxForm({
  form: FORM_NAME,
  validate: values => {
    if (!values.name) return { name: 'Required' }

    return null
  },
})(AccordionChildrenContent)

const mapStateToProps = (state, { appId, datasourceId, initialValues }) => {
  const { type } = initialValues
  const { tableId } = type

  return {
    relationshipTable: getTable(state, appId, datasourceId, tableId),
    googleApiKey: getThirdPartyApiKeyFor(state, appId, 'google'),
  }
}

const connected = connect(mapStateToProps)(WrappedAccordionChildrenContent)

export default connected
